import { useCurrentUser } from 'context/current-user-context'
import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'

declare global {
  interface Window {
    _hsq: any
    HubSpotCallsToActions: any
  }
}

const useHubspot = () => {
  const router = useRouter()
  const { email } = useCurrentUser()
  const firstLoad = useRef(true)

  const handleRouteChange = () => {
    const _hsq = window._hsq || []

    _hsq.push(['setPath', router.asPath])
    _hsq.push(['trackPageView'])
    if (typeof window.HubSpotCallsToActions !== 'undefined') {
      window.HubSpotCallsToActions.refresh()
    }
  }

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const _hsq = window._hsq || []

    if (email && firstLoad.current === true) {
      _hsq.push(['identify', { email }])
      firstLoad.current = false
      return
    }
  }, [email])

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router])

  return null
}

export default useHubspot
